import { postRequest, getRequest, putRequest } from '.';
import type { AuthProfile, Locale } from 'types';

interface MeResponse {
  profile: AuthProfile;
}

export const getStations = async () => getRequest('stations');
export const validateUser = async (email: string, stationId: string) =>
  postRequest('authenticate-user', { email, station_id: stationId });

export interface CheckUserResponse {
  exists: boolean;
  passwordless: boolean;
  enabled: boolean;
  userId?: string;
  username?: string;
  email?: string;
}

export const checkUser = async (userId: string): Promise<CheckUserResponse> => {
  const response = await postRequest<CheckUserResponse>('auth/check-user', { userId });

  if (!response) {
    throw new Error('Failed to check user');
  }

  return response;
};

export const getMe = async (): Promise<AuthProfile> => {
  const response = await getRequest<MeResponse>('auth/me');
  if (!response?.profile) {
    throw new Error('Failed to load profile');
  }
  return response.profile;
};

export const updateMyLocale = async (locale: Locale): Promise<AuthProfile> => {
  const response = await putRequest<MeResponse>('auth/me', { locale });
  if (!response?.profile) {
    throw new Error('Failed to update language');
  }
  return response.profile;
};
